import './App.css';

import { useRef } from 'react';

import GlobeComp from './GlobeComp'
import useDeviceType from './hooks/useDeviceType';  // Importing the custom hook

// const config = require('./config');

// console.log(`Running in ${config.environment} mode`);
// console.log(`API Endpoint: ${config.apiEndpoint}`);
console.log(`Running in ${process.env.REACT_APP_ENVIRONMENT} mode`);
console.log(`API Endpoint: ${process.env.REACT_APP_API_ENDPOINT}`);



function App() {
  const elementVariable = useRef(null);

  const isMobile = useDeviceType();  // Using the custom hook

  return (

    <div>
      <div className="floating-heading-container">
        <h1 className="title">Visa Requirements for British Citizens</h1>
        <p className="sub-heading">      {isMobile ? 'Tap a country to investigate their visa requirements' : 'Click a country to investigate their visa requirements'}
        </p>
      </div>

      <GlobeComp />
      <div className='floating-footer-container'>

        <p className='sub-heading'>Visa requirements are always changing. Please double check each official government website before booking flights for the most accurate and up-to-date information.</p>
      </div>
      <div ref={elementVariable}>
      </div>

    </div>
  );
}

export default App;
